import React, { useContext } from 'react';
import { AngularContext, AngularServicesContext } from 'react-app';
import { useSelector } from 'react-redux';
import { isEmpty } from 'underscore';
import { useAppDispatch } from 'redux/store';
import { setHasSeenAICourseSummaryModal } from 'redux/actions/ai-course-creation';
import { getCurrentCourseActiveAICreationCommand } from 'redux/selectors/course';
import { getCurrentUserId } from 'redux/selectors/timeline';
import CourseSummary from './course-summary';


const AiCreationCourseSummary = () => {
  const dispatch = useAppDispatch();
  const currentUserId = useSelector(getCurrentUserId);
  const currentAICreationCommand = useSelector(getCurrentCourseActiveAICreationCommand);
  const { TimelinesManager } = useContext(AngularServicesContext);

  const { injectServices } = React.useContext(AngularContext);
  const [CurrentCourseManager] = injectServices(['CurrentCourseManager']);


  // During EditMode the redux lecture sections are not getting updated after course generated. so using TimelinesManager.currentTimeline.lectureSections for checking courses are generated or not.

  const hasAIGeneratedLessons = TimelinesManager.isEditMode() && TimelinesManager.currentTimeline && (TimelinesManager.currentTimeline.lectureSections.length > 0 || TimelinesManager.currentTimeline.lectureSubsections.length > 0);


  const onCourseSummaryModalClose = () => {
    if (!currentAICreationCommand?.id) return;

    CurrentCourseManager.course.aiCreationCommands.find(command => command.id === currentAICreationCommand.id).requester.hasSeenCompletionModal = true;

    dispatch(setHasSeenAICourseSummaryModal({
      commandId: currentAICreationCommand.id,
      value: true,
    }));
  };

  const canShowCourseSummaryModal = hasAIGeneratedLessons && !isEmpty(currentAICreationCommand)
    && currentAICreationCommand?.requester?.id === currentUserId
    && !currentAICreationCommand?.inProgress
    && !currentAICreationCommand?.requester?.hasSeenCompletionModal
    && !!currentAICreationCommand?.summary;

  return (
    <div className='mt-5'>
      <CourseSummary
        showCourseSummaryModal={canShowCourseSummaryModal}
        handleCourseSummaryModal={onCourseSummaryModalClose}
      />
    </div>
  );
};

export default AiCreationCourseSummary;


